import React from 'react';
import { MonitorTask } from '../../services/klineMonitorService';

interface MonitorStatusPanelProps {
  monitorData: MonitorTask | null;
}

const MonitorStatusPanel: React.FC<MonitorStatusPanelProps> = ({ monitorData }) => {
  if (!monitorData?.currentData) {
    return null;
  }

  return (
    <div className="bg-white/5 border border-white/10 rounded-lg p-4 mb-4">
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <div className="text-white/60 mb-1">当前价格</div>
          <div className="text-white font-semibold">{monitorData.currentData.price ?? '-'}</div>
        </div>
        <div>
          <div className="text-white/60 mb-1">RSI(14)</div>
          <div className="text-white font-semibold">{monitorData.currentData.rsi14 ?? '-'}</div>
        </div>
        <div>
          <div className="text-white/60 mb-1">EMA(20)</div>
          <div className="text-white font-semibold">
            {monitorData.currentData.ema20 != null ? monitorData.currentData.ema20 : '-'}
          </div>
        </div>
        <div>
          <div className="text-white/60 mb-1">EMA(50)</div>
          <div className="text-white font-semibold">
            {monitorData.currentData.ema50 != null ? monitorData.currentData.ema50 : '-'}
          </div>
        </div>
        <div>
          <div className="text-white/60 mb-1">MACD</div>
          <div className="text-white font-semibold">{monitorData.currentData.macd?.macd ?? '-'}</div>
        </div>
        <div>
          <div className="text-white/60 mb-1">MACD信号线</div>
          <div className="text-white font-semibold">{monitorData.currentData.macd?.signal ?? '-'}</div>
        </div>
      </div>
    </div>
  );
};

export default MonitorStatusPanel;
